import { compose } from "redux";
import React, { PureComponent } from "react";
import { Grid, withStyles } from "@material-ui/core";

import { NoContentBasePage as AltusNoContentBasePage } from "altus-ui-components";

class NoContentBasePage extends PureComponent {
  render() {
    const { classes, ...rest } = this.props;

    return (
      <Grid item xs container justifyContent="center">
        <Grid container item xs={12} md={10}>
          <AltusNoContentBasePage
            classes={{
              children: classes.basePageRoot,
            }}
            {...rest}
          />
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  basePageChildren: {
    padding: `${theme.spacing(5)}px ${theme.spacing(2)}px`,
  },
});

export default compose(withStyles(styles))(NoContentBasePage);
